'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'envelope-open-text';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f658';
var svgPathData = ['M48 199.9c65.7 48.8 131.4 97.5 197.1 146.2 8.2 6.1 17.4 10.2 26.9 12.4l0 105-183.2 0C65.7 460 48 440.1 48 416l0-216.1z', 'M96 480c-35.3 0-64-28.7-64-64l0-248c0-12.6 6-24.5 16.1-32l197-146.2c25.5-18.9 60.3-18.9 85.8 0L527.9 136c3.1 2.3 5.8 5 8 8L511.8 144 321.4 2.7C301.6-12 274.4-12 254.6 2.7L57.6 148.9c-6 4.5-9.6 11.6-9.6 19.1s3.6 14.6 9.6 19.1l197 146.2c5.4 4 11.2 6.9 17.4 8.7l0 16.5c-9.5-2.2-18.7-6.3-26.9-12.4L48.1 200 48 199.9 48 416c0 26.5 21.5 48 48 48l176 0 0 16-176 0zM528 208l-160 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM368 192l160 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48zm24 96l112 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-112 0c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 64l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeOpenText = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;